import { useQuery } from '@tanstack/react-query'

import type { ModelsUserFullInfoResponse } from '@/api/generated-api'
import { loadApiClient } from '@/shared/api/lazyClient'
import { useAuthStore } from '@/stores/authStore'

export function useUserMe() {
  const isAuthenticated = useAuthStore(s => s.isAuthenticated)

  const query = useQuery<ModelsUserFullInfoResponse | undefined>({
    queryKey: ['me', isAuthenticated],
    queryFn: async () => {
      const api = await loadApiClient()
      return api.v2UsersMeList()
    },
    // Client fetch only — homepage HTML stays bfcache-eligible because this
    // route does not SSR /users/me (see app/[locale]/page.tsx). Disabling the
    // query on "/" left Header without name/avatar for authenticated users.
    enabled: isAuthenticated
  })

  return {
    // eslint-disable-next-line @tanstack/query/no-rest-destructuring -- convenience API: callers destructure { data, isLoading, hasToken } (OCE-527)
    ...query,
    hasToken: isAuthenticated
  }
}
